import './SimplePageHeader.less';

import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { fromJS } from 'immutable';

import HeaderArrowIcon from 'nike-ui/src/icons/svg/header-arrow-icon-sv.svg';
import HeaderCrossIcon from 'nike-ui/src/icons/svg/header-cross-icon-sv.svg';
import { buildTitle } from '@/ui/handlers';
import NikeLogoIcon from '@/icons/NikeLogoIcon';
import { SearchButton } from '@/fullsearch/views/SearchButton';
import { withRouter } from 'react-router-dom';
import { clearCashinClosingMode } from 'nike-ui/src/components/ticketus/handlers';
import { cashinClosingModeAnyActive$ } from 'nike-ui/src/components/ticketus/subs';

function SimplePageHeader({ children, pageFixerClassName, searchButtonActive, fixShadowClass }) {
    useEffect(() => {
        document.body.classList.add('main-tab-hidden');
        return () => {
            document.body.classList.remove('main-tab-hidden');
        };
    }, []);
    return (
        <>
            <div className={'page-header-sticker ' + fixShadowClass}>
                <HeaderTitleContentWithRouter searchButtonActive={searchButtonActive} />
                {children}
            </div>
            <div className={clsx('page-header-fixer', { pageFixerClassName }, pageFixerClassName)} />
        </>
    );
}

function HeaderTitleContent({ searchButtonActive, location }) {
    const { subscribe } = useReframe();
    const [state, setState] = useState(false);
    const fromApp = location?.state?.fromApp;
    const title = subscribe(['ui.headerTitle']);
    const cashinClosingModeActive = subscribe(cashinClosingModeAnyActive$);

    useEffect(() => {
        setState(fromApp);
    }, [fromApp]);

    function handleClick(e) {
        e.preventDefault();
        if (cashinClosingModeActive) {
            dispatch(clearCashinClosingMode);
        } else {
            dispatch(['history_back']);
        }
    }

    return (
        <nav className={clsx('simple-page-header-content', { search: searchButtonActive })}>
            <div className="header-btn-go-back" data-atid="main-menu-go-back" onClick={handleClick}>
                {state ? <HeaderArrowIcon /> : <HeaderCrossIcon />}
            </div>
            <div className="simple-page-header-content-title">
                <h1>
                    {title ? (
                        buildTitle(fromJS(title))
                    ) : (
                        <NikeLogoIcon width={49} height={27} opacity={1} fill={'#ff8000'} />
                    )}
                </h1>
            </div>
            {searchButtonActive && <SearchButton />}
        </nav>
    );
}

const HeaderTitleContentWithRouter = withRouter(HeaderTitleContent);

export default SimplePageHeader;
